import Cookies from 'js-cookie';
import { configFetch as fetch } from '@laigu/utils';

// 获取企业权限列表
export const getEnterprisePermsApi = () => {
  return fetch({
    url: '/perm/perms',
    method: 'get'
  });
};

// 获取客服权限列表（包含可见对话范围权限）
export const getAgentPermsApi = () => {
  const agentId = Cookies.get('_agent_id');
  return fetch({
    url: `/agent/agents/${agentId}/perms_ranges`,
    method: 'get'
  });
};
